// src/menuItems.tsx
import { type MenuItem } from "./components/Shared/SideBar";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SourceIcon from "@mui/icons-material/Source";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import LogoutIcon from "@mui/icons-material/Logout";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import SendIcon from '@mui/icons-material/Send';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Payment } from "@mui/icons-material";
import { TFunction } from "i18next";

/**
 * Generates the menu items based on the user's roles and name.
 * @param user The Userfront user object.
 * @param t The i18next translation function.
 * @returns An array of MenuItem objects.
 */
export const getMenuItems = (user: any | null, t: TFunction): MenuItem[] => {
  const baseMenuItems: MenuItem[] =
    user?.name === "demo"
      ? [
          { text: t("menu.dashboard"), path: "/dashboard", icon: <DashboardIcon /> },
          { text: t("menu.reports"), path: "/reports", icon: <AssessmentIcon /> },
          { text: t("menu.schedule"), path: "/schedule", icon: <EmailOutlinedIcon  /> },
        ]
      : [
          { text: t("menu.dashboard"), path: "/dashboard", icon: <DashboardIcon /> },
          { text: t("menu.reports"), path: "/reports", icon: <AssessmentIcon /> },
          { text: t("menu.schedule"), path: "/schedule", icon: <SendIcon  /> },
        ];

  const adminMenuItems: MenuItem[] = [
    {
      text: t("menu.administration"),
      icon: <AdminPanelSettingsIcon />,
      items: [
        { text: t("menu.adverts"), path: "/adverts", icon: <EmojiPeopleIcon /> },
        { text: t("menu.themes"), path: "/settings/themes", icon: <ColorLensIcon />, },
        { text: t("menu.systemParameters"), path: "/settings/sysparam", icon: <SettingsIcon />, },
        { text: t("menu.systemMetrics"), path: "/settings/sysmetric", icon: <MonitorHeartIcon />, },
        { text: t("menu.selectClient"), path: "/selectCustomer", icon: <BusinessIcon /> },
        { text: t("menu.accountingPoints"), path: "/points", icon: <LocationOnIcon /> },
        { text: t("menu.sources"), path: "/origins", icon: <SourceIcon /> },
        { text: t("menu.groups"), path: "/groups", icon: <GroupWorkIcon /> },
        { text: t("menu.persons"), path: "/persons", icon: <PersonIcon /> },
        { text: t("menu.reportsAdmin"), path: "/settings/report-list", icon: <AssessmentIcon /> },
      ],
    },
  ];

  const settingsMenuItems: MenuItem[] =
    user?.name === "demo"
      ? [
          {
            text: t("menu.settings"),
            icon: <SettingsIcon />,
            items: [
              {text: t("menu.general"), path: "/settings/general", icon: <SettingsIcon />},
              {text: t("menu.accountingPoints"), path: "/points", icon: <LocationOnIcon />},
            ],
          },
        ]
      : [
          {
            text: t("menu.settings"),
            icon: <SettingsIcon />,
            items: [
              {text: t("menu.general"), path: "/settings/general", icon: <SettingsIcon />},
              {text: t("menu.accountingPoints"), path: "/points", icon: <LocationOnIcon />},
              { text: t("menu.sources"), path: "/origins", icon: <SourceIcon /> },
              {text: t("menu.personGroups"), path: "/groups", icon: <GroupWorkIcon />},
              { text: t("menu.persons"), path: "/persons", icon: <PersonIcon /> },
            ],
          },
        ];

  const billingMenuItems: MenuItem[] = [
    { text: t("menu.billing"), path: "/billing", icon: <Payment />, },
  ];


  let currentMenuItems = [...baseMenuItems];

  if (user?.hasRole("admin")) {
    currentMenuItems = [...currentMenuItems, ...adminMenuItems];
  }
  currentMenuItems = [
    ...currentMenuItems,
    ...settingsMenuItems,
    ...billingMenuItems,
    { text: t("menu.logout", { userName: user?.username }), path: "/logout", icon: <LogoutIcon /> },
  ];

  return currentMenuItems;
};